import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Cancelar", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_6 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "ant-col ant-col-xs-10 ant-col-xl-10" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "ant-col ant-col-xs-2 ant-col-xl-2" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_17 = { class: "ant-col ant-col-xs-2 ant-col-xl-2" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "ant-col ant-col-xs-7 ant-col-xl-7" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "ant-row" }
const _hoisted_32 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_33 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_34 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_35 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_36 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_37 = {
  key: 1,
  class: "ant-col ant-col-xs-10 ant-col-xl-10"
}
const _hoisted_38 = { class: "ant-row" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-20 ant-col-xl-20" }, null, -1)
const _hoisted_40 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_41 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { key: 2 }
const _hoisted_46 = { key: 3 }
const _hoisted_47 = { key: 4 }
const _hoisted_48 = { key: 5 }
const _hoisted_49 = { key: 6 }
const _hoisted_50 = { key: 7 }
const _hoisted_51 = { key: 8 }
const _hoisted_52 = { key: 9 }
const _hoisted_53 = {
  key: 10,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { key: 11 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_tipo_rastreabilidade = _resolveComponent("selecionar-tipo-rastreabilidade")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_lancamento_rastreabilidade_lote = _resolveComponent("lancamento-rastreabilidade-lote")!
  const _component_card = _resolveComponent("card")!
  const _component_lancamento_rastreabilidade_armamento = _resolveComponent("lancamento-rastreabilidade-armamento")!
  const _component_lancamento_rastreabilidade_veiculo = _resolveComponent("lancamento-rastreabilidade-veiculo")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    title: "Lançamento de Rastreabilidades",
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 1000,
    centered: "",
    "wrap-class-name": _ctx.storeSistema.state.layoutMobile?'scroll-modal ss-modal-estoque':'ss-modal-estoque'
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalBase.computedVisivel = false))
        }, _hoisted_2),
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmar && _ctx.confirmar(...args)))
        }, _hoisted_4)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando,
        paragraph: { rows: 15 }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              (!_ctx.state.exibirFatorConversao)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_a_form_item, {
                        label: "NF",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            value: _ctx.props.codigoTipoOperacao,
                            disabled: ""
                          }, null, 8, _hoisted_7)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_a_form_item, {
                        label: "Cód. Produto",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            value: _ctx.state.definicaoProduto.codigoInterno,
                            disabled: ""
                          }, null, 8, _hoisted_9)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_a_form_item, {
                        label: "Descrição",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            value: _ctx.state.definicaoProduto.produto,
                            disabled: ""
                          }, null, 8, _hoisted_11)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_a_form_item, {
                        label: "UN",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            style: {"text-align":"center"},
                            value: _ctx.state.definicaoProduto.unidade,
                            disabled: ""
                          }, null, 8, _hoisted_13)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_a_form_item, {
                        label: "Qtd. Item",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            style: {"text-align":"right"},
                            value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.quantidade, _ctx.state.definicaoProduto.casasDecimais),
                            disabled: ""
                          }, null, 8, _hoisted_15)
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_a_form_item, {
                        label: "NF",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            value: _ctx.props.codigoTipoOperacao,
                            disabled: ""
                          }, null, 8, _hoisted_18)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_a_form_item, {
                        label: "Cód. Produto",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            value: _ctx.state.definicaoProduto.codigoInterno,
                            disabled: ""
                          }, null, 8, _hoisted_20)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_a_form_item, {
                        label: "Descrição",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            value: _ctx.state.definicaoProduto.produto,
                            disabled: ""
                          }, null, 8, _hoisted_22)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_a_form_item, {
                        label: "UN Entrada",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            style: {"text-align":"center"},
                            value: _ctx.props.siglaUnidade,
                            disabled: ""
                          }, null, 8, _hoisted_24)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_a_form_item, {
                        label: "Qtd. Entrada",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            style: {"text-align":"right"},
                            value: _ctx.UtilitarioMascara.mascararValor(_ctx.props.quantidade, _ctx.state.definicaoProduto.casasDecimais),
                            disabled: ""
                          }, null, 8, _hoisted_26)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_a_form_item, {
                        label: "UN Principal",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            style: {"text-align":"center"},
                            value: _ctx.state.definicaoProduto.unidade,
                            disabled: ""
                          }, null, 8, _hoisted_28)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_a_form_item, {
                        label: "Qtd. Item",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            style: {"text-align":"right"},
                            value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.quantidade, _ctx.state.definicaoProduto.casasDecimais),
                            disabled: ""
                          }, null, 8, _hoisted_30)
                        ]),
                        _: 1
                      })
                    ])
                  ])),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_a_form_item, {
                    label: "Tipo de Rastreabilidade",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_tipo_rastreabilidade, {
                        valor: _ctx.state.definicaoProduto.tipoRastreabilidade,
                        "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.definicaoProduto.tipoRastreabilidade) = $event)),
                        disabled: true
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_a_form_item, {
                    label: "Identificador",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "ant-input",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.rastreabilidade.identificador) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.state.rastreabilidade.identificador]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_a_form_item, {
                    label: "Descrição da Rastreabilidade",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "ant-input",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.rastreabilidade.descricao) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.state.rastreabilidade.descricao]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.definicaoProduto.tipoRastreabilidade == _ctx.ETipoRastreabilidade.Outros)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_a_form_item, {
                          label: "Observação",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.rastreabilidade.observacao) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.rastreabilidade.observacao]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_a_form_item, {
                          label: "Quantidade",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              valor: _ctx.state.rastreabilidade.qtdRastreabilidade,
                              "onUpdate:valor": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.rastreabilidade.qtdRastreabilidade) = $event)),
                              quantidadeCasasDecimais: _ctx.state.definicaoProduto.casasDecimais
                            }, null, 8, ["valor", "quantidadeCasasDecimais"])
                          ]),
                          _: 1
                        })
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createVNode(_component_a_form_item, {
                        label: "Observação",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.rastreabilidade.observacao) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.rastreabilidade.observacao]
                          ])
                        ]),
                        _: 1
                      })
                    ]))
              ]),
              (_ctx.state.definicaoProduto.tipoRastreabilidade === _ctx.ETipoRastreabilidade.Lote)
                ? (_openBlock(), _createBlock(_component_card, {
                    key: 2,
                    titulo: "Detalhes do Lote"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lancamento_rastreabilidade_lote, {
                        rastreabilidadeLote: _ctx.state.rastreabilidade.rastreabilidadeLote,
                        "onUpdate:rastreabilidadeLote": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.rastreabilidade.rastreabilidadeLote) = $event)),
                        qtdrastreabilidade: _ctx.state.rastreabilidade.qtdRastreabilidade,
                        "onUpdate:qtdrastreabilidade": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.rastreabilidade.qtdRastreabilidade) = $event)),
                        qtdCasasDecimais: _ctx.state.definicaoProduto.casasDecimais,
                        "onUpdate:qtdCasasDecimais": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.definicaoProduto.casasDecimais) = $event))
                      }, null, 8, ["rastreabilidadeLote", "qtdrastreabilidade", "qtdCasasDecimais"])
                    ]),
                    _: 1
                  }))
                : (_ctx.state.definicaoProduto.tipoRastreabilidade === _ctx.ETipoRastreabilidade.Armamento)
                  ? (_openBlock(), _createBlock(_component_card, {
                      key: 3,
                      titulo: "Detalhes do Armamento"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lancamento_rastreabilidade_armamento, {
                          rastreabilidadeArmamento: _ctx.state.rastreabilidade.rastreabilidadeArmamento,
                          "onUpdate:rastreabilidadeArmamento": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.rastreabilidade.rastreabilidadeArmamento) = $event))
                        }, null, 8, ["rastreabilidadeArmamento"])
                      ]),
                      _: 1
                    }))
                  : (_ctx.state.definicaoProduto.tipoRastreabilidade === _ctx.ETipoRastreabilidade.Veiculo)
                    ? (_openBlock(), _createBlock(_component_card, {
                        key: 4,
                        titulo: "Detalhes do Veículo"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_lancamento_rastreabilidade_veiculo, {
                            rastreabilidadeVeiculo: _ctx.state.rastreabilidade.rastreabilidadeVeiculo,
                            "onUpdate:rastreabilidadeVeiculo": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.rastreabilidade.rastreabilidadeVeiculo) = $event)),
                            empresa: _ctx.props.empresa,
                            qtdrastreabilidade: _ctx.state.rastreabilidade.qtdRastreabilidade,
                            "onUpdate:qtdrastreabilidade": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.rastreabilidade.qtdRastreabilidade) = $event)),
                            qtdCasasDecimais: _ctx.state.definicaoProduto.casasDecimais,
                            "onUpdate:qtdCasasDecimais": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.definicaoProduto.casasDecimais) = $event))
                          }, null, 8, ["rastreabilidadeVeiculo", "empresa", "qtdrastreabilidade", "qtdCasasDecimais"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary",
                    style: {"width":"100%","margin-top":"5px","margin-bottom":"5px"},
                    onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.adicionar && _ctx.adicionar(...args)))
                  }, _toDisplayString(_ctx.state.rastreabilidadeSelecionada === -1 ? 'Adicionar' : 'Editar'), 1)
                ])
              ]),
              _createVNode(_component_card, {
                titulo: "RASTREABILIDADES",
                class: "ss-padding-separacao-esquerda"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_table, {
                    columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                    "data-source": _ctx.state.rastreabilidades,
                    rowKey: "codigo",
                    pagination: false,
                    loading: _ctx.gradeBase.buscandoDados,
                    size: "small"
                  }, {
                    bodyCell: _withCtx(({ column, record, text, index }) => [
                      (column.key === 'acoes')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _createElementVNode("a", {
                              onClick: ($event: any) => (_ctx.editar(index))
                            }, [
                              _createVNode(_component_icone, { nome: "editar" })
                            ], 8, _hoisted_42),
                            _createElementVNode("a", {
                              onClick: ($event: any) => (_ctx.excluir(index))
                            }, [
                              _createVNode(_component_icone, { nome: "excluir" })
                            ], 8, _hoisted_43)
                          ]))
                        : (column.key === 'NumeroLote')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(record.rastreabilidadeLote.numeroLote), 1))
                          : (column.key === 'DataValidade')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.rastreabilidadeLote.dataValidade)), 1))
                            : (column.key === 'NumeroSerieArma')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(record.rastreabilidadeArmamento.numeroSerieArma), 1))
                              : (column.key === 'NumeroSerieCano')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(record.rastreabilidadeArmamento.numeroSerieCano), 1))
                                : (column.key === 'Chassi')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(record.rastreabilidadeVeiculo.chassi), 1))
                                  : (column.key === 'Ano')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(record.rastreabilidadeVeiculo.anoModeloFabricacao + "/" + record.rastreabilidadeVeiculo.anoFabricacao), 1))
                                    : (column.key === 'Cor')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(record.rastreabilidadeVeiculo.descricaoCor), 1))
                                      : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, _ctx.state.definicaoProduto.casasDecimais)), 1))
                                        : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinuto(text)), 1))
                                          : (column.key === 'Rastreabilidade')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                                (_ctx.state.definicaoProduto.tipoRastreabilidade === _ctx.ETipoRastreabilidade.Outros)
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                      _createElementVNode("span", null, "Identificador: " + _toDisplayString(record.identificador), 1),
                                                      _createElementVNode("span", null, "Descrição: " + _toDisplayString(record.descricao), 1),
                                                      _createElementVNode("span", null, "Qtd de Rastreabilidades: " + _toDisplayString(record.qtdRastreabilidade), 1),
                                                      _createElementVNode("span", null, "Qtd Inicial: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.qtdInicial, _ctx.state.definicaoProduto.casasDecimais)), 1)
                                                    ], 64))
                                                  : _createCommentVNode("", true),
                                                (_ctx.state.definicaoProduto.tipoRastreabilidade === _ctx.ETipoRastreabilidade.Lote)
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                      _createElementVNode("span", null, "Identificador: " + _toDisplayString(record.identificador), 1),
                                                      _createElementVNode("span", null, "Descrição: " + _toDisplayString(record.descricao), 1),
                                                      _createElementVNode("span", null, "Qtd de Rastreabilidades: " + _toDisplayString(record.qtdRastreabilidade), 1),
                                                      _createElementVNode("span", null, "Qtd Inicial: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.qtdInicial, _ctx.state.definicaoProduto.casasDecimais)), 1),
                                                      _createElementVNode("span", null, "Nº do Lote: " + _toDisplayString(record.rastreabilidadeLote.numeroLote), 1),
                                                      _createElementVNode("span", null, "Vencimento: " + _toDisplayString(record.rastreabilidadeLote.dataVencimento), 1)
                                                    ], 64))
                                                  : _createCommentVNode("", true),
                                                (_ctx.state.definicaoProduto.tipoRastreabilidade === _ctx.ETipoRastreabilidade.Armamento)
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                      _createElementVNode("span", null, "Identificador: " + _toDisplayString(record.identificador), 1),
                                                      _createElementVNode("span", null, "Descrição: " + _toDisplayString(record.descricao), 1),
                                                      _createElementVNode("span", null, "Qtd de Rastreabilidades: " + _toDisplayString(record.qtdRastreabilidade), 1),
                                                      _createElementVNode("span", null, "Qtd Inicial: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.qtdInicial, _ctx.state.definicaoProduto.casasDecimais)), 1),
                                                      _createElementVNode("span", null, "Nº da Arma: " + _toDisplayString(record.rastreabilidadeArmamento.numeroSerieArma), 1),
                                                      _createElementVNode("span", null, "Nº do Cano: " + _toDisplayString(record.rastreabilidadeArmamento.numeroSerieCano), 1)
                                                    ], 64))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("a", {
                                                  onClick: ($event: any) => (_ctx.editar(index))
                                                }, [
                                                  _createVNode(_component_icone, { nome: "editar" })
                                                ], 8, _hoisted_54),
                                                _createElementVNode("a", {
                                                  onClick: ($event: any) => (_ctx.excluir(index))
                                                }, [
                                                  _createVNode(_component_icone, { nome: "excluir" })
                                                ], 8, _hoisted_55)
                                              ]))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(text), 1))
                    ]),
                    emptyText: _withCtx(() => [
                      _createVNode(_component_mensagem_sem_dados, {
                        resultadoPesquisa: true,
                        mensagem: "Nenhuma rastreabilidade lançada."
                      })
                    ]),
                    _: 1
                  }, 8, ["columns", "data-source", "loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}